const textEl = document.createElement('div');

export default function countOf(html, selector = '.highlighted') {
   textEl.innerHTML = html;
   return textEl.querySelectorAll(selector).length;
}
